/**
 * UI component to highlight checkpoint nodes within a content module
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

const NextNode = ({
  match
  , node
  , onNodeClick
  , scene
  , viewedNodes
}) => {
  const hasViewed = _.includes(viewedNodes, node._id);
  const linkClass = classNames(
    'node-link'
    , { '-visited': hasViewed }
  )
  const iconClass = classNames(
    'fas fa-lg -icon'
    , {
      'fa-chevron-right': !hasViewed 
      , 'fa-check-circle': hasViewed && node.correct == "correct"
      , 'fa-times-circle': hasViewed && node.correct == "incorrect"
      , 'fa-ban': hasViewed
    }
  )
  return (
    <li>
      <Link
        className={linkClass}
        onClick={() => onNodeClick(node._id)}
        to={`${match.url.replace(match.params.nodeId, node._id)}?prev=${match.params.nodeId}`}
      >
        {scene.title}
        <i className={iconClass}/>
      </Link>
    </li>
  )
}

NextNode.propTypes = {
  node: PropTypes.object.isRequired
  , onNodeClick: PropTypes.func.isRequired
  , scene: PropTypes.object.isRequired
  , viewedNodes: PropTypes.array
}

NextNode.defaultProps = {
  viewedNodes: []
}

export default withRouter(NextNode);



// WEBPACK FOOTER //
// modules/node/components/NextNode.js.jsx